import { render, staticRenderFns } from "./baking.vue?vue&type=template&id=04d0d5aa&scoped=true"
import script from "./baking.vue?vue&type=script&lang=js"
export * from "./baking.vue?vue&type=script&lang=js"
import style0 from "./baking.vue?vue&type=style&index=0&id=04d0d5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d0d5aa",
  null
  
)

export default component.exports